module.exports = __webpack_public_path__ + "static/media/CouponMt.214a9f25.svg";